import {
  Avatar,
  Button,
  Card,
  Input,
  Row,
  Select,
  Steps,
  Tabs,
} from "antd";
import styled from "styled-components";

// New AI JDV Page Styles
export const AIJDVPageWrapper = styled.div`
  width: 100%;
  position: relative;
  min-height: calc(100vh - 200px);
  background: linear-gradient(180deg, rgba(250, 249, 255, 0.5) 0%, #ffffff 100%);
  border: 1px solid #edeef3;
  border-radius: 16px;
  overflow: hidden;
  @media (max-width: 768px) {
    margin-top: 60px;
  }
`;

export const AIJDVHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  min-height: 60px;
  background: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid #edeef3;
`;

export const AIJDVBackButton = styled(Button)`
  width: 40px;
  height: 40px;
  min-width: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid rgba(61, 41, 105, 0.2);
  background: ${({ theme }) => theme.colors.white};

  svg, img {
    color: #0a1b39;
  }

  &:hover {
    border-color: ${({ theme }) => theme.settings.primary};
    background: ${({ theme }) => theme.colors.white} !important;
  }
`;

export const AIJDVTitle = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #0a1b39;
  margin: 0;
`;

export const AIJDVTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 0;
    background: ${({ theme }) => theme.settings.whiteColor};
    border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};

    &::before {
      display: none;
    }
  }

  .ant-tabs-tab {
    padding: 14px 24px;
    margin: 0;

    .ant-tabs-tab-btn {
      font-family: ${({ theme }) => theme.fonts.inter};
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: ${({ theme }) => theme.settings.primary};
    }

    &:hover {
      .ant-tabs-tab-btn {
        color: ${({ theme }) => theme.settings.primary};
      }
    }

    &.ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        font-weight: 500;
        color: ${({ theme }) => theme.settings.primary};
      }
    }
  }

  .ant-tabs-ink-bar {
    background: ${({ theme }) => theme.settings.primary};
  }

  .ant-tabs-content-holder {
    padding: 24px;
  }
`;

export const AIJDVFormSection = styled.div`
  margin-bottom: 24px;
`;

export const AIJDVSectionTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #0a1b39;
  margin: 0 0 16px 0;
`;

export const AIJDVFieldLabel = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #1f2430;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;

  .info-icon {
    width: 12px;
    height: 12px;
    color: #8893a1;
    cursor: help;
  }
`;

export const AIJDVFieldDescription = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #666;
  display: block;
  margin-top: 4px;
`;

export const AIJDVFormRow = styled(Row)`
  margin-bottom: ${props => props.$mb || '24px'};
`;

export const AIJDVFormRowHeader = styled(Row)`
  margin-bottom: 8px;
`;

export const AIJDVLoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #666;
`;

export const AIJDVNoMarginFormItem = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-form-item-control-input-content > input.ant-input {
    height: 48px !important;
  }
`;

export const AIJDVDisabledInput = styled.div`
  .ant-input[disabled],
  .ant-input-disabled {
    background: rgba(61, 41, 105, 0.1) !important;
  }
`;

export const AIJDVVoiceFiltersRow = styled(Row)`
  margin-bottom: 24px;
`;

export const AIJDVFooterWithMargin = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  background: transparent;
  margin-top: 24px;
`;

export const AIJDVInput = styled.input`
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 30px;
  color: #1f2430;
  background: ${({ theme }) => theme.colors.white};

  &::placeholder {
    color: #828282;
  }

  &:focus {
    outline: none;
    border-color: #3d2969;
  }

  &:disabled {
    background: rgba(61, 41, 105, 0.1);
    color: #1f2430;
  }
`;

export const AIJDVTextArea = styled.textarea`
  width: 100%;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1f2430;
  background: ${({ theme }) => theme.colors.white};
  resize: vertical;
  min-height: 140px;

  &::placeholder {
    color: #828282;
  }

  &:focus {
    outline: none;
    border-color: #3d2969;
  }
`;

export const AIJDVSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    height: 48px !important;
    border: 1px solid #f0f0f0 !important;
    border-radius: 10px !important;
    padding: 0 16px !important;
    background: ${({ theme }) => theme.colors.white} !important;

    .ant-select-selection-item {
      font-family: 'Montserrat', sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 46px !important;
      color: #1f2430;
    }

    .ant-select-selection-placeholder {
      font-family: 'Montserrat', sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 46px !important;
      color: #828282;
    }
  }

  &:hover .ant-select-selector,
  &.ant-select-focused .ant-select-selector {
    border-color: #3d2969 !important;
  }

  .ant-select-arrow {
    color: #1f2430;
  }
`;

export const AIJDVFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  background: transparent;
`;

export const AIJDVPrimaryButton = styled(Button)`
  height: 42px;
  min-width: 112px;
  padding: 0 16px;
  border-radius: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  background: #3d2969 !important;
  border: 1px solid #3d2969 !important;
  color: ${({ theme }) => theme.colors.white} !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: #2a1b4b !important;
    border-color: #2a1b4b !important;
  }

  svg, img {
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const AIJDVSecondaryButton = styled(Button)`
  height: 42px;
  min-width: 112px;
  padding: 0 16px;
  border-radius: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  background: ${({ theme }) => theme.colors.white} !important;
  border: 1px solid rgba(61, 41, 105, 0.2) !important;
  color: #3d2969 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    border-color: #3d2969 !important;
    background: ${({ theme }) => theme.colors.white} !important;
  }

  svg, img {
    color: #3d2969;
  }
`;

export const AIJDVGhostButton = styled(Button)`
  height: 40px;
  padding: 0 16px;
  border-radius: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  background: transparent !important;
  border: 1px solid rgba(61, 41, 105, 0.1) !important;
  color: #3d2969 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    border-color: #3d2969 !important;
    background: transparent !important;
  }

  svg, img {
    color: #3d2969;
  }
`;

// Voice Card Styles Updated
export const AIJDVVoiceGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const AIJDVVoiceCard = styled.div`
  width: calc(33.333% - 11px);
  min-width: 260px;
  height: 80px;
  padding: 0 20px;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 12px;

  &:hover {
    border-color: rgba(61, 41, 105, 0.3);
  }

  &.selected {
    background: rgba(61, 41, 105, 0.1);
    border-color: rgba(61, 41, 105, 0.1);
  }

  @media (max-width: 1200px) {
    width: calc(50% - 8px);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const AIJDVVoiceAvatar = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AIJDVVoiceAvatarPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  background-color: ${({ $bgColor }) => $bgColor || '#3d2969'};
`;

export const AIJDVVoiceInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AIJDVVoiceName = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #0a1b39;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AIJDVVoiceMeta = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #8893a1;
`;

export const AIJDVVoiceSpeakerButton = styled(Button)`
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  border: none;
  background: transparent !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    font-size: 20px;
    color: #8893a1;
  }

  &:hover {
    background: transparent !important;
    svg {
      color: #3d2969;
    }
  }
`;

// Interview Dialogues Section
export const AIJDVDialogueWrapper = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.white};
`;

export const AIJDVDialogueHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: rgba(61, 41, 105, 0.05);
  border-bottom: 1px solid #f0f0f0;
`;

export const AIJDVDialogueHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    font-size: 18px;
    color: #1f2430;
  }

  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 30px;
    color: #1f2430;
  }
`;

export const AIJDVDialogueHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 30px;
    color: #1f2430;
  }
`;

export const AIJDVDialogueBody = styled.div`
  padding: 16px 20px;
`;

export const AIJDVDialogueItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.white};
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const AIJDVDialogueNumber = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(10, 27, 57, 0.1);
  border-radius: 6px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #0a1b39;
  background: ${({ theme }) => theme.colors.white};
`;

export const AIJDVDialogueInput = styled.div`
  flex: 1;
  padding: 8px 16px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #0a1b39;
  min-height: 40px;
  display: flex;
  align-items: center;
`;

export const AIJDVDialogueTimeWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 6px 29px 0px rgba(89, 108, 148, 0.07);
`;

export const AIJDVDialogueTimeInput = styled.div`
  width: 60px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #f0f0f0;
  border-radius: 6px 0 0 6px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #0a1b39;
`;

export const AIJDVDialogueTimeUnit = styled.div`
  width: 60px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eae7f0;
  border: 1px solid #f0f0f0;
  border-left: none;
  border-radius: 0 6px 6px 0;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #0a1b39;
`;

export const AIJDVAddDialogueButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  border: 1px dashed #eae7f0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 12px;

  &:hover {
    border-color: #3d2969;
  }

  svg {
    font-size: 18px;
    color: #3d2969;
  }

  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #3d2969;
  }
`;

export const AIJDVDialogueFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #f5f4f7;
  border-top: 1px solid #f0f0f0;

  .dialogue-count {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    color: #0a1b39;
  }

  .dialogue-duration {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: #0a1b39;

    strong {
      font-weight: 600;
    }
  }
`;

export const OptionCard = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  padding: 7px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: 40px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 30px;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transform: translateY(-2px);
  }

  /* Mobile styles */
  @media (max-width: 768px) {
    border-radius: 12px;
    margin-bottom: 12px;
    padding: 12px 12px 60px 12px;
    display: flex;
    align-items: center;
    justify-content: start;
    min-height: 56px;
    flex-wrap: nowrap;
  }
`;
export const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }
`;

export const TealIcon = styled(IconContainer)`
  &.cyanIcon {
    background: ${({ theme }) => theme.settings.cyanColor};
  }
  &.orangeIcon {
    background: ${({ theme }) => theme.settings.orangeColor};
  }
  &.blueIcon {
    background: ${({ theme }) => theme.settings.blueColor};
  }
`;

export const CardContent = styled.div`
  flex: 1;
  text-align: left;
  @media (max-width: 768px) {
    text-align: start;
    width: 100%;
    display: block;
  }
`;

export const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.settings.primary};
  margin: 0;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const CardDescription = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.settings.secondary};
  line-height: 18px;
  margin: 0;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const ChevronButton = styled(Button)`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.primary};
  color: ${({ theme }) => theme.settings.primary};
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  svg,
  img {
    color: ${({ theme }) => theme.settings.primary};
    filter: ${({ theme }) => theme.settings.imgFilterColor};
  }
  &:hover {
    background: ${({ theme }) => theme.settings.primary} !important;
    border: 1px solid ${({ theme }) => theme.settings.primary} !important;
    color: ${({ theme }) => theme.settings.whiteColor} !important;
    svg,
    img {
      color: ${({ theme }) => theme.settings.whiteColor} !important;
      filter: ${({ theme }) => theme.settings.imgFilterWhite} !important;
    }
  }
  @media (max-width: 768px) {
    width: 100% !important;
    height: 40px !important;
    position: absolute;
    right: 0px !important;
    left: 0px !important;
    bottom: 0px !important;
    border-radius: 0px 0px 10px 10px !important;
    border: none;
    border-top: 1px solid ${({ theme }) => theme.settings.borderColor};
  }
`;
export const ThemeSteps = styled(Steps)`
  .ant-steps-item-tail,
  .ant-steps-item-icon {
    display: none !important;
    @media (max-width: 768px) {
      display: block !important;
    }
  }
  .ant-steps-item {
    min-width: 60px;
    margin: 0px !important;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    border-radius: 40px !important;
    padding: 5px 15px !important;
    margin-right: 10px !important;
    @media (max-width: 768px) {
      min-width: 10px;
    }
    .ant-steps-item-container {
      padding: 0px !important;
      @media (max-width: 768px) {
        display: none;
      }
      &:hover {
        background: transparent !important;
      }
    }
    .ant-steps-item-title {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      margin: 0px !important;
      color: ${({ theme }) => theme.colors.primary} !important;
      font-size: 14px !important;
      font-weight: 400 !important;
    }
    .ant-steps-item-content {
      margin: 0px !important;
    }
    &.ant-steps-item-active {
      background: ${({ theme }) => theme.colors.primary} !important;
      border: 1px solid ${({ theme }) => theme.colors.primary} !important;
      color: ${({ theme }) => theme.colors.white} !important;
      .ant-steps-item-title {
        color: ${({ theme }) => theme.colors.white} !important;
      }
    }
  }
  .stepCustomTitle {
    @media (max-width: 768px) {
      display: none;
    }
  }
`;
export const XStepsWrapper = styled.div`
  .contentWrapper {
    width: 100%;
    position: relative;
    margin-top: 30px;
    min-height: calc(100vh - 270px);
    .mainTitle {
      width: 100%;
      position: relative;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: ${({ theme }) => theme.colors.secondary};
      span {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        color: ${({ theme }) => theme.colors.textColor};
      }
    }
  }
`;
export const SuggestButton = styled(Button)`
  background: transparent;
  padding: 0px;
  height: auto;
  border: none;
  box-shadow: none;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  svg,
  img {
    filter: ${({ theme }) => theme.colors.imgFilterColor};
    color: ${({ theme }) => theme.colors.primary};
  }
  &:hover,
  &:focus-within,
  &:active,
  &:visited {
    color: ${({ theme }) => theme.colors.primary} !important;
    svg,
    img {
      filter: ${({ theme }) => theme.colors.imgFilterColor};
      color: ${({ theme }) => theme.colors.primary} !important;
    }
  }
  &.largeIcon {
    font-size: 22px;
  }
`;
export const VoiceCard = styled(Card)`
  width: 100%;
  position: relative;
  transition: all 0.3s ease;
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  .ant-card-body {
    padding: 16px;
  }
  .cartTitle {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.secondary};
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    span {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: ${({ theme }) => theme.colors.textColor};
    }
  }
  &:hover,
  &.selected {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
    background: ${({ theme }) => theme.colors.bodyBg};
    color: ${({ theme }) => theme.colors.secondary};
    button {
      /* svg,
      img {
        color: ${({ theme }) => theme.colors.white} !important;
        filter: ${({ theme }) => theme.colors.imgFilterWhite} !important;
      } */
      &:hover {
        background: transparent !important;
        color: ${({ theme }) => theme.colors.primary} !important;
        svg,
        img {
          color: ${({ theme }) => theme.colors.primary} !important;
          filter: ${({ theme }) => theme.colors.imgFilterColor} !important;
        }
      }
    }
    /* .cartTitle {
      color: ${({ theme }) => theme.colors.white};
      span {
        color: ${({ theme }) => theme.colors.white};
      }
    } */
  }
`;
export const ThemeCustomTable = styled.div`
  .tableCard {
    font-family: ${({ theme }) => theme.fonts.inter};
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 16px;
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    transition: all 0.3s ease;
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
      border-radius: 20px 0px 20px 0px !important;
    }

    /* Mobile responsive styles */
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      padding: 16px;
      gap: 12px;
      position: relative;
      padding-bottom: 60px; /* Space for options button */
    }

    @media (max-width: 480px) {
      padding: 12px;
      gap: 8px;
      padding-bottom: 50px;
    }
  }

  .pollName {
    flex: 1;
    min-width: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.secondary};

    @media (max-width: 768px) {
      width: 100%;
      font-size: 16px;
      line-height: 22px;
      padding: 10px 0px 0px 0px;
      border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
    }

    @media (max-width: 480px) {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .duration {
    flex-shrink: 0;
    min-width: 80px;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary};

    @media (max-width: 768px) {
      min-width: auto;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  .model {
    flex-shrink: 0;
    min-width: 80px;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary};

    @media (max-width: 768px) {
      min-width: auto;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  .date {
    flex-shrink: 0;
    min-width: 100px;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary};

    @media (max-width: 768px) {
      min-width: auto;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  .status {
    flex-shrink: 0;
    min-width: 80px;
    font-size: 12px;
    font-weight: 500;

    @media (max-width: 768px) {
      min-width: auto;
      position: absolute;
      bottom: 16px;
      right: 16px;
    }

    @media (max-width: 480px) {
      bottom: 12px;
      right: 12px;
    }
  }

  .options {
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.secondary};
    button {
      font-size: 24px;
      color: ${({ theme }) => theme.colors.secondary};
      svg,
      img {
        color: ${({ theme }) => theme.colors.secondary};
        filter: ${({ theme }) => theme.colors.imgFilterColor};
      }
    }

    @media (max-width: 768px) {
      position: absolute;
      top: 16px;
      right: 16px;
      button {
        font-size: 20px;
      }
    }

    @media (max-width: 480px) {
      top: 12px;
      right: 12px;
      button {
        font-size: 18px;
      }
    }
  }

  /* Mobile info row */
  @media (max-width: 768px) {
    .tableCard {
      .mobile-info-row {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        width: 100%;
        margin-top: 8px;
      }
    }
  }
`;
export const ThemeCustomTableAvatar = styled(Avatar)`
  font-family: ${({ theme }) => theme.fonts.inter};
  background-color: rgba(52, 109, 213, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px !important;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.secondary};
`;

// Survey Modal Styles
export const AIJDVModalSearchWrapper = styled.div`
  padding: 20px 20px 0;
  margin-bottom: 16px;
`;

export const AIJDVModalSearchInput = styled(Input)`
  width: 100%;
  height: 48px;
  border: 1px solid #f0f0f0 !important;
  border-radius: 10px !important;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #1f2430;

  .ant-input {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #1f2430;
  }

  &::placeholder {
    color: #828282;
  }

  &:hover, &:focus, &.ant-input-focused {
    border-color: #3d2969 !important;
  }
`;

export const AIJDVModalSelectButton = styled(Button)`
  height: 32px;
  min-width: 80px;
  padding: 0 16px;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  background: #3d2969 !important;
  border: 1px solid #3d2969 !important;
  color: #ffffff !important;

  &:hover {
    background: #2a1b4b !important;
    border-color: #2a1b4b !important;
  }

  &:active {
    transform: scale(0.95);
  }
`;

// Modal card-style tabs matching ThemeUserManagementTabs
export const AIJDVModalTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0 !important;
  }

  .ant-tabs-tab {
    background: #f0f0f0 !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 16px !important;

    .ant-tabs-tab-btn {
      font-family: ${({ theme }) => theme.fonts.inter};
      color: ${({ theme }) => theme.settings.primary};
    }

    &:hover {
      background: ${({ theme }) => theme.settings.gradientBg} !important;
      .ant-tabs-tab-btn {
        color: ${({ theme }) => theme.settings.whiteColor} !important;
      }
    }
  }

  .ant-tabs-tab-active {
    background: ${({ theme }) => theme.settings.gradientBg} !important;
    .ant-tabs-tab-btn {
      color: ${({ theme }) => theme.settings.whiteColor} !important;
    }
  }

  .ant-tabs-content-holder {
    border: 1px solid #f0f0f0 !important;
    border-top: none !important;
    padding: 0;
  }
`;

// Modal Table Wrapper with custom scrollbar
export const AIJDVModalTableWrapper = styled.div`
  border-top: 1px solid #f0f0f0;

  .ant-table-thead > tr > th:first-child,
  .ant-table-tbody > tr > td:first-child {
    padding-left: 20px !important;
  }

  .ant-table-thead > tr > th:last-child,
  .ant-table-tbody > tr > td:last-child {
    padding-right: 20px !important;
  }

  .ant-pagination {
    padding: 0 20px 12px;
  }

  .ant-table-body {
    scrollbar-width: thin;
    scrollbar-color: #d9d9d9 #f5f5f5;

    &::-webkit-scrollbar {
      width: 4px !important;
    }

    &::-webkit-scrollbar-track {
      background: #f5f5f5 !important;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: #d9d9d9 !important;
      border-radius: 2px;

      &:hover {
        background: #bfbfbf !important;
      }
    }
  }
`;

// Voice Modal Scrollable Area
export const AIJDVVoiceModalScrollable = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  padding-right: 8px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3px;
    
    &:hover {
      background: #bfbfbf;
    }
  }
`;
